/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-confusing-browser-globals */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import I18n from 'I18n';
import Url from 'urlinator/Url';
import usageTracker from '../lib/usageTracker';
const twitterShareBaseURL = 'https://twitter.com/intent/tweet';
const facebookShareBaseURL = 'http://www.facebook.com/share.php';
const linkedInShareBaseURL = 'https://www.linkedin.com/shareArticle';
export default class ShareIcons extends Component {
  constructor(...args) {
    super(...args);

    this.getShareText = () => {
      return I18n.text('results.share.shareText');
    };

    this.getTwitterShareUrl = currentUrl => {
      const url = new Url(twitterShareBaseURL);
      url.pushParam('text', this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('hashtags', I18n.text('results.share.shareHashtag'));
      return url.href;
    };

    this.getFacebookShareUrl = currentUrl => {
      const url = new Url(facebookShareBaseURL);
      url.pushParam('title', this.getShareText());
      url.pushParam('u', currentUrl);
      return url.href;
    };

    this.getLinkedInShareUrl = currentUrl => {
      const url = new Url(linkedInShareBaseURL);
      url.pushParam('title', this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('summary', this.getShareText());
      return url.href;
    };

    this.onIconClick = socialMediaPlatform => {
      usageTracker.log('socialSharingClick', {
        websiteUrl: this.props.websiteUrl,
        socialMediaPlatform
      });
    };
  }

  render() {
    const currentUrl = location.href;
    return /*#__PURE__*/_jsxs("div", {
      className: "share-icons",
      children: [/*#__PURE__*/_jsx("a", {
        className: "icon icon-twitter",
        href: this.getTwitterShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => this.onIconClick('twitter')
      }), /*#__PURE__*/_jsx("a", {
        className: "icon icon-facebook",
        href: this.getFacebookShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => this.onIconClick('facebook')
      }), /*#__PURE__*/_jsx("a", {
        className: "icon icon-linkedin",
        href: this.getLinkedInShareUrl(currentUrl),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => this.onIconClick('linkedin')
      })]
    });
  }

}